<template>
  <div class="container-fluid mt-2">
    <h2>Angebote</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" @keyup="updateSearch()" id="search" v-model="search" type="text"/>
      </div>
    </div>
    <b-table @row-clicked="openOffer" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(deliverDate)="data">
        {{ data.item.deliverdate }}
      </template>
      <template v-slot:cell(sum)="data">
        {{ Number(data.item.netto).toFixed(2) }}
      </template>
      <template v-slot:cell(status)="data">
        {{ calcStatus(data.item) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import offers from '@/modules/offers.js'

export default {
  name: 'OfferList',
  props:['customer'],
  data() {
    return {
      search: "",
      rows: [],
      fields: [
        {label:"Angebot-Nr.",key:"map_id"},
        {label:"Kunde-Nr",key:"customer.map_id"},
        {label:"Kunde",key:"customer.title"},
        {label:"Erstellt",key:"created"},
        {label:"Lieferdatum",key:"deliverDate"},
        {label:"Summe",key:"sum"},
        {label:"Vertreter",key:"handid"},
        {label:"Status",key:"status"}
      ]
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      offers.list(function(data) {
        self.rows = data.rows;
      })
    },
    openOffer(row) {
      router.push({ name:'OfferView',params: {offerid: row.id }});
    },
    calcStatus: function(row) {
      if (row.status == 2) return 'Übermittelt'; else if (row.status == 0) return 'Neu'; else return 'Fehler';
    },
    updateSearch: function() {
      offers.viewparams.search = this.search;
      this.fetchData();
    },
    prevPage: function() {
      if (offers.viewparams.page > 1) {
        offers.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        offers.viewparams.page++;
        this.fetchData();
      }
    }
  }
}
</script>
